<script lang="ts">
    import KpVisitedPanel from '../../kp-visited-documents-panel/KpVisitedPanel.svelte';
</script>

<div class="side-column-panel">
    <KpVisitedPanel showLastVisited="{false}"/>
</div>